module.exports = __webpack_public_path__ + "static/q1_o-4a43863276a591847f805d0c53ccd860.png";